import React from 'react';
import { Box, Typography, Grid, Divider } from '@mui/material';

const Field = ({ label, value }) => (
  <Box sx={{ mb: 2 }}>
    <Typography variant="subtitle2" color="textSecondary">
      {label}
    </Typography>
    <Typography variant="body1" sx={{ mt: 0.5, whiteSpace: 'pre-wrap' }}>
      {value}
    </Typography>
  </Box>
);

const ChangeRequestDetailsView = ({ details }) => {
  if (!details) return null;

  return (
    <Box
      sx={{
        p: 2,
        borderRadius: 2,
        background: 'linear-gradient(180deg, #e3f2fd 0%, #f5f5f5 100%)',
        border: '1px solid #90caf9'
      }}
    >
      <Typography variant="h6" sx={{ color: '#0d47a1', fontWeight: 700, mb: 2 }}>
        Change Request Form
      </Typography>

      {details.raisedAt && (
        <Box sx={{ mb: 1 }}>
          <Typography variant="subtitle2" color="textSecondary">
            Raised At
          </Typography>
          <Typography variant="body1">
            {new Date(details.raisedAt).toLocaleString()}
          </Typography>
        </Box>
      )}

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <Field
            label="Change Requester"
            value={`${details.requesterFirstName} ${details.requesterLastName}`}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Field label="Email" value={details.email} />
        </Grid>
      </Grid>

      <Divider sx={{ my: 1 }} />

      <Field label="Proposed Change" value={details.proposedChange} />
      <Field label="Reasons for Change" value={details.changeReasons} />
      <Field label="Change Impact" value={details.changeImpact} />
    </Box>
  );
};

export default ChangeRequestDetailsView;
